import React from 'react';
import { useTranslation } from 'react-i18next';
import { Search } from 'lucide-react';

interface ShulSearchProps {
  value: string;
  onChange: (value: string) => void;
}

export default function ShulSearch({ value, onChange }: ShulSearchProps) {
  const { t } = useTranslation();

  return (
    <div className="relative">
      <Search className="absolute top-1/2 -translate-y-1/2 start-3 w-4 h-4 text-ash pointer-events-none" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t('common.search')}
        className="w-full ps-9 pe-3 py-2 rounded-[10px] border border-ink bg-paper text-ink placeholder:text-ash focus:outline-none focus:ring-2 focus:ring-ink/30 focus:border-ink text-sm"
      />
    </div>
  );
}
